import r from "./highrise1509.mjs";
var o = function() {
  try {
    var e = r(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
export {
  o as default
};
